// src/components/AddEditStaffModal/components/BasicInfoTab.js
import React from 'react';
import {
    Divider,
    Grid,
    IconButton,
    MenuItem,
    Typography,
} from '@material-ui/core';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import { CustomTextField } from '../../../Textfield';
import { CustomDatePicker } from '../../../DateTimePicker';
import { LabeledSwitch, StyledMenuItem } from './FormUI';
import { GeofenceAutoApprovalIcon } from '../../../../assets/svg';
import { TrackingEnabledIcon } from '../../../../assets/svg';
import { SelfieAttendanceIcon } from '../../../../assets/svg';
import { useSelector } from 'react-redux';
import moment from 'moment';

export default function BasicInfoTab({
    handlers,
    vehicleTypesList,
    vendorList,
    formik,
}) {
    const staffTypes = useSelector((state) => state?.staff?.types);
    const leadSources = useSelector((state) => state?.staff?.leadSources);
    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <CustomTextField
                    label="Staff Name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    name="name"
                    isRequired={true}
                    fullWidth
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                />
            </Grid>

            <Grid item xs={3}>
                <CustomTextField
                    label="Staff Type"
                    select
                    fullWidth={true}
                    value={formik.values?.staffTypeId ?? ''}
                    name="staffTypeId"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    defaultValue=""
                    style={{
                        marginBottom: '16px',
                        //width: '50%',
                        marginRight: 5,
                    }}
                    error={
                        formik.touched.staffTypeId &&
                        Boolean(formik.errors.staffTypeId)
                    }
                    helperText={
                        formik.touched.staffTypeId && formik.errors.staffTypeId
                    }
                    isRequired
                >
                    {staffTypes?.length ? (
                        staffTypes.map((hub, index) => (
                            <StyledMenuItem key={index} value={hub.id}>
                                {hub.name}
                            </StyledMenuItem>
                        ))
                    ) : (
                        <StyledMenuItem value={null}>
                            No Data Found
                        </StyledMenuItem>
                    )}
                </CustomTextField>
            </Grid>
            <Grid item xs={3}>
                <CustomTextField
                    label="Phone Number"
                    value={formik.values.contactNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    name="contactNumber"
                    isRequired={true}
                    fullWidth
                    error={
                        formik.touched.contactNumber &&
                        Boolean(formik.errors.contactNumber)
                    }
                    helperText={
                        formik.touched.contactNumber &&
                        formik.errors.contactNumber
                    }
                />
            </Grid>

            <Grid item xs={6}>
                <CustomDatePicker
                    label="Date of Join"
                    value={formik.values.joiningDateEpochMillis}
                    name="joiningDateEpochMillis"
                    onChange={(e) => {
                        formik.handleChange({
                            target: {
                                name: 'joiningDateEpochMillis',
                                value: e,
                            },
                        });
                    }}
                    onBlur={formik.handleBlur}
                    showInput
                    InputProps={{
                        endAdornment: (
                            <IconButton>
                                <InsertInvitationIcon />
                            </IconButton>
                        ),
                    }}
                    fullWidth
                    isRequired={true}
                    error={
                        formik.touched.joiningDateEpochMillis &&
                        Boolean(formik.errors.joiningDateEpochMillis)
                    }
                    helperText={
                        formik.touched.joiningDateEpochMillis &&
                        formik.errors.joiningDateEpochMillis
                    }
                />
            </Grid>

            <Grid item xs={6}>
                <CustomDatePicker
                    label="Date of Birth"
                    value={
                        moment(
                            formik.values.dateOfBirthEpochMillis,
                        )?.valueOf() > 0 &&
                        moment()?.diff(
                            moment(formik.values.dateOfBirthEpochMillis),
                            'years',
                        ) >= 18
                            ? formik.values.dateOfBirthEpochMillis
                            : null
                    }
                    name="dateOfBirthEpochMillis"
                    onChange={(e) => {
                        formik.handleChange({
                            target: {
                                name: 'dateOfBirthEpochMillis',
                                value: e,
                            },
                        });
                    }}
                    onBlur={formik.handleBlur}
                    showInput={true}
                    allowAge18={false}
                    allowFutureDates={false}
                    InputProps={{
                        endAdornment: (
                            <IconButton>
                                <InsertInvitationIcon />
                            </IconButton>
                        ),
                    }}
                    fullWidth
                    isRequired={true}
                    error={
                        formik.touched.dateOfBirthEpochMillis &&
                        Boolean(formik.errors.dateOfBirthEpochMillis)
                    }
                    helperText={
                        formik.touched.dateOfBirthEpochMillis &&
                        formik.errors.dateOfBirthEpochMillis
                    }
                />
            </Grid>

            <Grid item xs={6}>
                <CustomTextField
                    label="Vehicle Type"
                    value={formik.values.vehicleTypeId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    name="vehicleTypeId"
                    select
                    fullWidth
                    isRequired={true}
                    error={
                        formik.touched.vehicleTypeId &&
                        Boolean(formik.errors.vehicleTypeId)
                    }
                    helperText={
                        formik.touched.vehicleTypeId &&
                        formik.errors.vehicleTypeId
                    }
                >
                    {vehicleTypesList?.length ? (
                        vehicleTypesList?.map((vehicle, index) => (
                            <StyledMenuItem key={index} value={vehicle?.id}>
                                {vehicle?.value}
                            </StyledMenuItem>
                        ))
                    ) : (
                        <StyledMenuItem value={null}>
                            No Data Found
                        </StyledMenuItem>
                    )}
                </CustomTextField>
            </Grid>

            {!!formik.values.vehicleTypeId && (
                <Grid item xs={6}>
                    <CustomTextField
                        label="Vehicle Number"
                        value={formik.values.vehicleNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="vehicleNumber"
                        isRequired={true}
                        fullWidth
                        error={
                            formik.touched.vehicleNumber &&
                            Boolean(formik.errors.vehicleNumber)
                        }
                        helperText={
                            formik.touched.vehicleNumber &&
                            formik.errors.vehicleNumber
                        }
                    />
                </Grid>
            )}

            <Grid item xs={12}>
                <Typography
                    style={{
                        fontSize: '18px',
                        fontWeight: 600,
                        marginBottom: '18px',
                    }}
                    variant="body1"
                >
                    Attendance Setup
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <LabeledSwitch
                            title="Enable Selfie"
                            icon={
                                <SelfieAttendanceIcon
                                    width={24}
                                    height={24}
                                    style={{
                                        marginRight: '8px',
                                    }}
                                />
                            }
                            checked={formik.values.selfieEnabled}
                            name="selfieEnabled"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <LabeledSwitch
                            title="Enable Track & Trace"
                            icon={
                                <TrackingEnabledIcon
                                    width={24}
                                    height={24}
                                    style={{
                                        marginRight: '8px',
                                    }}
                                />
                            }
                            checked={formik.values.trackAndTraceEnabled}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="trackAndTraceEnabled"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <LabeledSwitch
                            title="Enable Geofence Auto Approval"
                            icon={
                                <GeofenceAutoApprovalIcon
                                    width={24}
                                    height={24}
                                    style={{
                                        marginRight: '8px',
                                    }}
                                />
                            }
                            checked={formik.values.geofenceAutoApproval}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="geofenceAutoApproval"
                        />
                    </Grid>
                </Grid>
                <Divider />
            </Grid>

            <Grid item xs={12}>
                <Typography
                    style={{
                        fontSize: '18px',
                        fontWeight: 600,
                        marginBottom: '18px',
                    }}
                    variant="body1"
                >
                    Source of Delivery Boy
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <CustomTextField
                            label={
                                formik?.values?.userCreationSource
                                    ? 'Source'
                                    : 'Select rider source'
                            }
                            select
                            fullWidth={true}
                            value={formik?.values?.userCreationSource ?? ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="userCreationSource"
                            defaultValue=""
                            style={{
                                marginBottom: '16px',
                                width: '100%',
                                marginRight: 5,
                            }}
                            isRequired={true}
                        >
                            {leadSources?.staticValues?.length &&
                                leadSources.staticValues.map(
                                    (source, index) => (
                                        <StyledMenuItem
                                            key={index}
                                            value={source.name}
                                        >
                                            {source.name}
                                        </StyledMenuItem>
                                    ),
                                )}
                        </CustomTextField>
                    </Grid>
                    {formik?.values.userCreationSource &&
                        formik?.values.userCreationSource === 'Vendor' && (
                            <Grid item xs={6}>
                                <CustomTextField
                                    label={
                                        formik?.values?.vendorId
                                            ? 'Vendor'
                                            : 'Select Vendor'
                                    }
                                    select
                                    fullWidth={true}
                                    value={formik?.values?.vendorId ?? ''}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    name="vendorId"
                                    defaultValue=""
                                    style={{
                                        marginBottom: '16px',
                                        width: '100%',
                                        marginRight: 5,
                                    }}
                                    isRequired={true}
                                >
                                    {vendorList?.length ? (
                                        vendorList?.map((vendor, index) => (
                                            <StyledMenuItem
                                                key={index}
                                                value={vendor?.vendorId}
                                            >
                                                {vendor?.name}
                                            </StyledMenuItem>
                                        ))
                                    ) : (
                                        <StyledMenuItem value={null}>
                                            No Data Found
                                        </StyledMenuItem>
                                    )}
                                </CustomTextField>
                            </Grid>
                        )}
                    <Grid item xs={6}>
                        <CustomTextField
                            fullWidth={true}
                            label={
                                formik?.values?.sourceRemarks
                                    ? 'Remarks'
                                    : 'Enter remarks if any'
                            }
                            value={formik?.values?.sourceRemarks}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="sourceRemarks"
                            style={{ marginBottom: '16px' }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
